import { Leaf, Heart, FlaskConical, Smile } from "lucide-react";
import { motion } from "framer-motion";

const SkincareSpecial = () => {
  const highlights = [
    {
      icon: <Leaf className="w-8 h-8 text-[#809080]" />,
      title: "Sustainable & Clean",
      desc: "Made with eco-friendly ingredients and recyclable packaging.",
    },
    {
      icon: <FlaskConical className="w-8 h-8 text-[#809080]" />,
      title: "Gentle Formulas",
      desc: "Free from parabens, synthetic fragrance, and harsh chemicals.",
    },
    {
      icon: <Smile className="w-8 h-8 text-[#809080]" />,
      title: "Tailored to You",
      desc: "Each product is designed for your unique skin needs.",
    },
    {
      icon: <Heart className="w-8 h-8 text-[#809080]" />,
      title: "Cruelty-Free Love",
      desc: "No animal testing — just kindness in every jar.",
    },
  ];

  return (
    <section className="bg-[#f5eee6] py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#7a6e5f]">
          What Makes Our Skincare Special
        </h2>
        <p className="mt-4 text-[#7a6e5f] opacity-80 max-w-xl mx-auto">
          We don’t believe in one-size-fits-all. At SuprSkin, your skin's story inspires everything we create.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {highlights.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.2 }}
            className="bg-white rounded-xl shadow p-6 text-center"
          >
            <div className="flex justify-center mb-4">{item.icon}</div>
            <h3 className="font-semibold text-lg text-[#7a6e5f] mb-2">
              {item.title}
            </h3>
            <p className="text-sm text-[#7a6e5f] opacity-80">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default SkincareSpecial;
